/* eslint-disable @typescript-eslint/member-ordering */
import { Component, OnInit, Input } from '@angular/core';
import { SeriesOptionsType } from 'highcharts';
import { Charts } from 'src/app/shared/model/activity';
import { ChartService } from 'src/app/shared/services/chart.service';
import * as Highcharts from 'highcharts';
import { Action, UserActivityService } from 'src/app/shared/services/user-activity.service';
import { TranslateService } from '@ngx-translate/core';
import { FilterParameters, WidgetsOptions } from '../analytics.component';
import { clone } from '@okta/okta-auth-js';

@Component({
  selector: 'app-actions-analytics',
  templateUrl: '../shared-template/analytics-template.html',
  styleUrls: ['../shared-template/analytics-template.scss'],
})
export class ActionsAnalyticsComponent extends Charts implements OnInit {
  @Input() filterParameters: FilterParameters;

  public componentLoaded = false;
  public widgetsOptions: WidgetsOptions[] = [];
  public pageLoading = true;

  private userActionsData;
  private actionsActivityData;
  private userActionsDrilldownSeries;

  routesCount: { id: string; count: number}[];
  highcharts: typeof Highcharts = Highcharts;

  constructor(
    private chartService: ChartService,
    private userActivityService: UserActivityService,
    private translateService: TranslateService
  ) {
    super();
  }

  ngOnInit(): void {
    this.componentLoaded = true;
    this.filter(this.filterParameters);
  }

  loadWidgets(options: Highcharts.Options[]) {
    const defaultClass = 'defaultChart';
    this.widgetsOptions = [];
    options.forEach( option => {
      this.widgetsOptions.push(new WidgetsOptions(option, defaultClass));
    });
  }

  public filter(params: FilterParameters): void {
    this.userActionsData = [];
    this.pageLoading = true;
    this.userActivityService.getActivitiesSummariesWithActions(
      params.createdFrom,
      params.createdTo,
      params.selectedRadioRange
    )
    .then(res => {
      this.userActionsData = this.mergeActionDuplicates(clone(res.actions))
        .map(item => ({name:item.action, drilldown:item.action, y:item.count}))
        .sort((c1, c2) => c2.y - c1.y);
      const drilldownSeriesNames = res.actions.map(item => item.action).reduce(
        (previous, current)=> previous.includes(current) ? previous : previous.concat([current]),
        []
      );
      this.userActionsDrilldownSeries = drilldownSeriesNames.map((name) => ({
        name,
        id: name,
        data: res.actions.filter(item => item.action === name).map(item => [item.page, item.count])
      }));
      this.actionsActivityData = res.actionsPerDay.map(item => ([new Date(item.id).getTime(), item.count]));
      this.loadWidgets(this.generateChartsOptions());
      this.pageLoading = false;
    });
  }

  generateChartsOptions(): Highcharts.Options[] {
    // Define user activities widget
    const actionsActivitySeries: SeriesOptionsType[] = [
      {
        name: this.translateService.instant('pages.dashboard.analytics.dailyActions'),
        data: this.actionsActivityData,
        type: 'line'
      },
    ];
    const options = [
      this.chartService.initColumnOptions(
        this.translateService.instant('pages.dashboard.analytics.userActions'),
        this.translateService.instant('pages.dashboard.analytics.occurrences'),
        this.translateService.instant('pages.dashboard.analytics.userActions'),
        this.userActionsData,
        this.userActionsDrilldownSeries,
        this.translateService.instant('pages.dashboard.analytics.occurrences')
      ),
      this.chartService.initLineChartOptions(
        this.translateService.instant('pages.dashboard.analytics.actionsActivity'),
        this.translateService.instant('pages.dashboard.analytics.userActions'),
        actionsActivitySeries
      )
    ];
    return options;
  }

  public mergeActionDuplicates(actions: Action[]) {
    const actionNames: string[] = [];
    const mergedDuplicates: Action[] = [];
    actions.forEach( (item: Action) => {
      if (!actionNames.includes(item.action)) {
        actionNames.push(item.action);
        mergedDuplicates.push(item);
      } else {
        mergedDuplicates.forEach( action => {
          if (action.action === item.action) {
            action.count += item.count;
          }
        });
      }
    });
    return mergedDuplicates;
  }
}
